import { Component, Mixins } from "vue-property-decorator";
import RequestsMixin from "@/mixins/http/RequestsMixin";
import CompanyMixin from "@/mixins/http/CompanyMixin";
import AnalysisMixin from "@/mixins/http/AnalysisMixin";

@Component
class AnalysisService extends Mixins(AnalysisMixin) {}

export default new AnalysisService();
